<template>
    <q-card id="coastalSummaryPane" class="q-pa-sm" v-bind="attrs">
        <div class="text-body2 q-pa-sm" v-if="finalData">
            <!-- <div class="text-h7 underline text-uppercase">Diversity</div>
            <ul class="q-mt-xs">
                <li  v-if="finalData['overallDiv'] !=''">The area is considered overall high diversity for &nbsp;<span class="text-bold">{{ finalData['overallDiv'] }}</span></li>
                <li v-if="finalData['coastalBirdDivCount'] && finalData['coastalBirdDivCount'] > 1">The month(s) when coastal bird diversity is highest ({{ finalData['coastalBirdDivCount'] }} species at high levels): <span class="text-bold">{{ finalData['coastalBirdDivMonth'] }}</span></li>
                <li v-else>There are no months when &gt;1 coastal bird species is found at high levels.</li>
            </ul>

            <div class="text-h7 underline text-uppercase">Species</div>
            <div class="text-body2 text-italic">Species' use of <span class="strong">coastal</span> habitats:</div>
            <ul class="q-mt-xs">
                <li>
                    Species of birds that are ESA listed: 
                    <span class="text-bold"  v-if="finalData['summaryItems']['esaBirds'] !=''">{{ finalData['summaryItems']['esaBirds'] }}</span>
                    <span v-else class="text-bold">None</span>
                </li>
                <li>
                    Species of birds in the area that are listed as endangered or threatened by one of the states: 
                    <span class="text-bold"  v-if="finalData['summaryItems']['stateBirds'] !=''">{{ finalData['summaryItems']['stateBirds'] }}</span>
                    <span v-else class="text-bold">None</span>
                </li>
                <li>
                    Species of birds that are considered of high conservation need: 
                    <span class="text-bold"  v-if="finalData['summaryItems']['sgcnBirds'] !=''">{{ finalData['summaryItems']['sgcnBirds'] }}</span>
                    <span v-else class="text-bold">None</span>
                </li>
            </ul> -->

            <div class="text-h7 underline text-uppercase">Habitats</div>
            <ul class="q-mt-xs">
                <li>
                    The area has the following coastal habitats: 
                    <span class="text-bold"  v-if="finalData['summaryItems']['habitats'] !='None / No Data' && finalData['summaryItems']['habitats'] !=''">{{ finalData['summaryItems']['habitats'] }}</span>
                    <span v-else class="text-bold">None</span>
                    <span v-if="finalData['summaryItems']['coastalFeats'] !='None / No Data' && finalData['summaryItems']['coastalFeats'] !=''">. It also overlaps with: </span>
                    <span class="text-bold"  v-if="finalData['summaryItems']['coastalFeats'] !='None / No Data' && finalData['summaryItems']['coastalFeats'] !=''">{{ finalData['summaryItems']['coastalFeats'] }}</span>
                </li>
                <li>
                    <span   v-if="finalData['summaryItems']['saltMarsh'] !='None / No Data' && finalData['summaryItems']['saltMarsh'] !=''">Some saltmarshes in this area are considered stable (although there are parts of the area that have different UVVR values).</span> 
                    <span v-else>No saltmarshes within the area have been identified as stable</span>
                    <q-btn dense size="xs" flat class="gray" icon="help_outline" @click="infoDialogs['stable'].model = !infoDialogs['stable'].model" aria-label="Stable saltmarsh data help"/>
                </li>
                <li>
                    <span v-if="finalData['summaryItems']['seagrass'] !='None / No Data' && finalData['summaryItems']['seagrass'] !=''">Some or all seagrass beds in this area are known to be Highly persistent, which highlights areas where seagrass occurs frequently over time.</span>
                    <span v-else>No persistent seagrass beds have been identified in the area</span>
                    <q-btn dense size="xs" flat class="gray" icon="help_outline" @click="infoDialogs['persistence'].model = !infoDialogs['persistence'].model" aria-label="Stable saltmarsh data help"/>
                </li>

            </ul>

            <div class="text-h7 underline text-uppercase">Opportunities</div>
            <ul class="q-mt-xs">
                <li>
                    <span v-if="finalData['summaryItems']['diad'] !='None / No Data'">This is an area that is known for being <span class="text-bold">high value for diadromous species</span>. </span>
                    <span v-else>This is not a coastal area that is known for being high value for diadromous species.</span>
                </li>
                <li v-if="finalData['hasMarshMig']">
                    This area includes <span class="text-bold">marsh migration space</span> with greater than average resilience.
                </li>
                <li v-else>
                    No marshe migration space with greater than average resilience was identiifed in the area. 
                </li>

                <li v-if="finalData['hasSaltmarshSparrowMarshes']">
                    This area includes <span v-if="finalData['hasPriorityMarshes']">priority marshes</span><span v-if="finalData['hasPriorityMarshes'] && finalData['hasReferenceMarshes']"> and</span><span v-if="finalData['hasReferenceMarshes']"> reference marshes</span> identified for saltmarsh sparrow.
                </li>
                <li v-else>
                    No priority or reference marshes for saltmarsh sparrow were identified in the area.
                </li>

                <li v-if="finalData['hasFlyoverHotspots']">
                    This area includes <span v-if="finalData['hasSpringHotSpot']">spring</span><span v-if="finalData['hasSpringHotSpot'] && finalData['hasAutumnHotSpot']"> and</span><span v-if="finalData['hasAutumnHotSpot']"> autumn </span> hotspots identified for migratory bird stopover.
                </li>
                <li v-else>
                    This area has not been identified as a stopover hotspot for migratory birds.
                </li>
            </ul>
            <div class="text-h7 underline text-uppercase">Coastal Restoration Projects</div>
            <ul class="q-mt-xs">
                <li>
                    <span v-if="finalData['restorationProjectCount'] > 0">
                        This area includes <span class="text-bold">{{ finalData['restorationProjectCount'] }} restoration project<span v-if="finalData['restorationProjectCount'] !== 1">s</span></span>.
                    </span>
                    <span v-else>No coastal restoration projects were identified in this area.</span>
                </li>
            </ul>
            <div class="text-h7 underline text-uppercase">Threats</div>
            <ul>
                <li>
                    <span v-if="finalData['coastalHabitatChangeAcres'] > 0">
                        This area includes {{ finalData['coastalHabitatChangeAcres'].toLocaleString() }} acres of coastal <span class="text-bold">habitat likely to change</span>.
                    </span>
                    <span v-else>No coastal habitat likely to change was identified in this area.</span>
                </li>
                <li>
                    <span v-if="finalData['hazardHighAcres'] > 0">
                        This area includes {{ finalData['hazardHighAcres'].toLocaleString() }} acres with <span class="text-bold">high likelihood of hazard</span>.
                    </span>
                    <span v-else>No high likelihood hazard areas were identified in this area.</span>
                </li>
            </ul>

            <div class="text-caption text-italic">
                NOTE: This list does not reflect any mitigation or conservation requirements already in place in this area. 
            </div>
        </div>  
    </q-card>

    <div v-for="(infoObj, name) in infoDialogs" :key="name" >
        <q-dialog v-model="infoObj.model">
            <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
        </q-dialog>
    </div>
</template>
<script setup lang="ts">
//@ts-nocheck
import { toRefs, ref, computed, onMounted, useAttrs } from "vue";
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import InfoDialog from "./InfoDialog.vue";
import { AllCodes } from "../assets/SppCodesToNames.json"
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const attrs = useAttrs()
const {  tileLayers, toggleLayer, print, printing, ecos, setActiveHabSpotlight, setProcessedData, processedData, loadDataByID, activeLayerID } = useMapItems()
const { arrayFindObjectByProp, getPropForLargestValue, arrayListToString, getPropsForLargestValue } = useHelpers();

const props = defineProps({
    data: { type: Object },
    version: {type: Number}
})

const { data, version } = toRefs(props)

const summaryData =  computed(() =>{
    if (data.value && data.value["COASTAL_SUMMARY"] && data.value["COASTAL_SUMMARY"].length >0){
        return data.value["COASTAL_SUMMARY"]
    }
    else{ return null}
})


const finalData = computed(() => {
    if (
        !processedData.value[version.value] || 
        processedData.value[version.value]['COASTAL_SUMMARY'] === undefined ||
        processedData.value[version.value]['COASTAL_SUMMARY']['a'] === undefined ||
        processedData.value[version.value]['COASTAL_SUMMARY']['a']['a'] === undefined
    ){
        if (summaryData.value) {
            const finalData = {
                "overallDiv": "",
            }
            const workingValues = {}

            ///////// CONFIGURE working objects
            const diverseGroupsAttrs = ["DIV_BIC"]
            diverseGroupsAttrs.forEach((attr) =>{
                workingValues[attr] = false
            })

            // setup object for most diverse mammal month
            const birdDivMonthAttrs = ["DIV_BIC_01", "DIV_BIC_02", "DIV_BIC_03", "DIV_BIC_04", "DIV_BIC_05", "DIV_BIC_06", "DIV_BIC_07", "DIV_BIC_08","DIV_BIC_09","DIV_BIC_10","DIV_BIC_11", "DIV_BIC_12"]
            birdDivMonthAttrs.forEach((attr) =>{
                workingValues[attr] = []
            })
            
            // setup for endangered/threated/SGCN species
            for (const [theme, spArr] of Object.entries(potentialThingLists)) {
                workingValues[theme] ={}
                spArr.forEach((attr) =>{
                    workingValues[theme][attr] = []
                })
            }


            /////////// PROCESS CELL DATA

            let hasMarshMig = false;
            let hasPriorityMarshes = false;
            let hasReferenceMarshes = false;
            let hasSpringHotSpot = false;
            let hasAutumnHotSpot = false;
            const restorationUIDs = new Set<string>();
            let coastalHabitatChangeAcres = 0;
            let hazardHighAcres = 0;

            summaryData.value.forEach((cell) => {
               // overall species diversity
                diverseGroupsAttrs.forEach((attr) =>{
                    if (cell[attr] == 1){
                        workingValues[attr] = true
                    }
                })

                // most diverse mammal month
                birdDivMonthAttrs.forEach((attr) =>{
                    workingValues[attr].push(cell[attr])
                })

                // populate cell values into endangered/threated/SGCN species object
                for (const [theme, spArr] of Object.entries(potentialThingLists)) {
                    spArr.forEach((attr) =>{
                        workingValues[theme][attr].push(cell[attr])
                    })
                }

                if (Number(cell['marshMig_aa']) > 0) {
                    hasMarshMig = true
                }
                if (Number(cell['PriorityMarshes']) > 0) {
                    hasPriorityMarshes = true
                }
                if (Number(cell['ReferenceMarshes']) > 0) {
                    hasReferenceMarshes = true
                }
                if (Number(cell['SpringHotSpot']) > 0) {
                    hasSpringHotSpot = true
                }
                if (Number(cell['AutumHotSpot']) > 0) {
                    hasAutumnHotSpot = true
                }
                if (cell['UIDs']) {
                    cell['UIDs'].split(',').map((uid: string) => uid.trim()).filter((uid: string) => uid).forEach((uid: string) => restorationUIDs.add(uid))
                }
                const ccl3Value = Number(cell['CCL3_all']) || 0
                coastalHabitatChangeAcres += ccl3Value * 247.105381
                const hazHighValue = Number(cell['HAZ_High']) || 0
                hazardHighAcres += hazHighValue * 247.105381
            })

            /////// PROCESS FINAL DATA
            // calc final overall species diversity
            const overallDiv = []
            diverseGroupsAttrs.forEach((attr) =>{
                if (workingValues[attr]){
                    overallDiv.push(prettyText[attr])
                }
            })
            finalData['overallDiv'] = arrayListToString(overallDiv)

            // get most diverse coastal bird month
            const birdmonth = {}
            birdDivMonthAttrs.forEach((attr) =>{
                birdmonth[attr] = Math.max(...workingValues[attr])
            })
            finalData['coastalBirdDivMonth'] = prettyText[getPropForLargestValue(birdmonth)]
            const birdDivRes = getPropsForLargestValue(birdmonth)
            finalData['coastalBirdDivMonth'] = getPrettyTextList(birdDivRes.keys)
            finalData['coastalBirdDivCount'] = birdDivRes.value

            // populate cell values into endangered/threated/SGCN species object
            const summaryItems = {}
            const summaryItemsFinal  ={}
            let anyData = false
            for (const [theme, spArr] of Object.entries(potentialThingLists)) {
                summaryItems[theme] = []
                for (const [sp, values] of Object.entries(workingValues[theme])) {
                    const valuesArray = values as number[]; // Type assertion
                    // console.log(valuesArray)
                    if (Math.max(...valuesArray) == 1 && !summaryItems[theme].includes(prettyText[sp] ?? AllCodes[sp] ?? sp)) {
                        if (theme == 'habitats' || theme == 'coastalFeats' || theme == 'saltMarsh' || theme == 'seagrass'){
                            summaryItems[theme].push(prettyText[sp]);
                        }
                        else if (theme == 'diad' || theme == 'coastRes'){
                            summaryItems[theme].push(sp);
                        }
                        else{
                            summaryItems[theme].push(AllCodes[sp]);
                        }
                        anyData = true
                    }
                    
                }
            }
            // console.log(summaryItems['habitats'])
            for (const [theme, textArr] of Object.entries(summaryItems)) {
                summaryItemsFinal[theme] = arrayListToString(textArr)    
            }
            finalData['summaryItems'] = summaryItemsFinal
            finalData['hasMarshMig'] = hasMarshMig
            finalData['hasSaltmarshSparrowMarshes'] = hasPriorityMarshes || hasReferenceMarshes
            finalData['hasPriorityMarshes'] = hasPriorityMarshes
            finalData['hasReferenceMarshes'] = hasReferenceMarshes
            finalData['hasFlyoverHotspots'] = hasSpringHotSpot || hasAutumnHotSpot
            finalData['hasSpringHotSpot'] = hasSpringHotSpot
            finalData['hasAutumnHotSpot'] = hasAutumnHotSpot
            finalData['restorationProjectCount'] = restorationUIDs.size
            finalData['coastalHabitatChangeAcres'] = roundToSignificantFigures(coastalHabitatChangeAcres, 2)
            finalData['hazardHighAcres'] = roundToSignificantFigures(hazardHighAcres, 2)

            console.log(finalData)
            setProcessedData(version.value, "COASTAL_SUMMARY", 'a', 'a', finalData)
            return finalData
        }
        else{
            return null
        }
    }
    else{
        // console.log("Loading ", processedData.value[version.value]['COASTAL_SUMMARY']['a']['a'])
        return processedData.value[version.value]['COASTAL_SUMMARY']['a']['a']
    }
    
})
const goTo = (obj) =>{
    if(obj.params){
        if (obj.params.type == 'habSpotlight'){
            setActiveHabSpotlight(obj.params.value)
            setProcessedData('habSpotlight', obj.params.value)
        }
    }

    if (obj.link){
        // console.log(route.fullPath)
        const path = `${obj.link}`
        router.push(path)
    }
    // console.log(obj)
}

const getPrettyTextList = (codeList) =>{
    if (codeList){
        let text = ""
        codeList.forEach((code) =>{
            text += prettyText[code] + ", "
        })
        return text.slice(0, -2); 
    }
    else{
        return null
    }
}

const roundToSignificantFigures = (value, sig = 2) => {
    const num = Number(value)
    if (!Number.isFinite(num) || num === 0) return 0
    const sign = Math.sign(num)
    const absVal = Math.abs(num)
    const exponent = Math.floor(Math.log10(absVal))
    const factor = 10 ** (sig - exponent - 1)
    return Math.round(absVal * factor) / factor * sign
}

const prettyText = {

    "DIV_BIC" : "coastal birds", 
    "DIV_BIC_01" : "January", 
    "DIV_BIC_02": "February", 
    "DIV_BIC_03": "March", 
    "DIV_BIC_04": "April", 
    "DIV_BIC_05": "May", 
    "DIV_BIC_06": "June", 
    "DIV_BIC_07": "July", 
    "DIV_BIC_08": "August",
    "DIV_BIC_09": "September",
    "DIV_BIC_10": "October",
    "DIV_BIC_11": "Novemeber", 
    "DIV_BIC_12": "December",
    "PIPL" : "Piping plover", 
    "ROST" : "Roseate Tern", 
    "REKN" : "Red Knot", 
    "AMOY": "American Oystercatcher", 
    "BLTE": "Black Tern", 
    "LEBI": "Least Bittern",  
    "LETE": "Least Tern",  
    "BLSK": "Black Skimmer", 
    "COTE": "Common Tern", 
    "FOTE": "Forster's Tern", 
    "GBTE": "Gull-billed Tern", 
    "WETL": "wetlands", 
    "SAND": "sand/dunes", 
    "ROC": "rocky shore", 
    "SEAG": "seagrass",
    "ESTU": "estuaries", 
    "BARR": "coastal barrier islands", 
    "SMISL": "small islands",
    "UVVR": "salt marsh",
    "PERS": "seagrass",
    null: "None / No Data"
}

const potentialThingLists = {
    "esaBirds" : ["PIPL", "ROST", "REKN"],
    "stateBirds" :["AMOY",  "BLTE", "LEBI", "LETE", "BLSK", "COTE", "FOTE", "GBTE", "ROYT"],
    "sgcnBirds" :["REKN", "PUSA", "PIPL", "ROST", "BLSK", "LETE", "AMBD", "RTLO", "WWSC"],
    "habitats" :["WETL", "SAND", "ROC", "SEAG"],
    "coastalFeats":["ESTU", "BARR", "SMISL"],
    "saltMarsh" : ["UVVR"],
    "seagrass" :["PERS"],
    "diad" : ["ODIA"]
}

const infoDialogs = ref({
    wetlands: {
        pName: "Coastal Marshes",
        model: false,
        text: "More info about the importance of coastal marshes."
    },
    stable :{
        pName: "Stable Salt Marshes",
        model: false,
        text: "Marsh stability is assessed using the unvegetated to vegetated ratio (UVVR).  As UVVR increases, marsh stability decreases."  
    },
    persistence :{
        pName: "Seagrass Persistence",
        model: false,
        text: "The extent of seagrass can vary from year to year due to natural cycles.  Places that persistently support seagrass over many years are identified for their importance to support other amrine life."  

    }
})

onMounted(() => {
  if (activeLayerID.value != 'COASTAL_SUMMARY'){
    loadDataByID('COASTAL_SUMMARY', version)
  }
})
</script>
<style scoped>
.row-title{
    background-color: #cacaca;
}
</style>